export const ILLUSTRATIONS_URL = 'https://assets.zeiss.com/illustrations';

export const RUDDERSTACK_BASE_URL_STAGE =
  'https://zeissstnctlrfc.dataplane.rudderstack.com';

export const RUDDERSTACK_BASE_URL_PROD =
  'https://zeissalesqpl.dataplane.rudderstack.com';

export const RUDDERSTACK_WRITE_KEY_STAGE =
  'MnZvOU4wdzBpU296OTlmMHRTMGF2cDVhY1lnOg==';

export const RUDDERSTACK_WRITE_KEY_PROD =
  'MnZuaEs4ZHBhbGlHckV5cVRzckw1blF5VWw1Og==';

export const RUDDERSTACK_SESSION_STORAGE_KEY = 'rl_session_id';

export const TRACK_REQUEST_TIMEOUT = 3000; // 3 seconds

export const ONETRUST_STATISTICS_GROUP_ID = 'C0002';
